import React, { useState, memo } from 'react';
import PropTypes from 'prop-types';
import { RefreshCw, ChevronRight } from 'lucide-react';

const WeatherMaps = () => {
  const [mapsLoading, setMapsLoading] = useState({ wind: true, radar: true });

  return (
    <div className="bg-white/95 dark:bg-gray-800/95 backdrop-blur rounded-xl shadow-lg p-5 border border-orange-100 dark:border-gray-700 animate-on-scroll card-hover hover-lift">
      <h3 className="font-semibold text-lg mb-4 dark:text-gray-100">🗺️ Weather Maps</h3>
      
      {/* Wind Map */}
      <div className="mb-4">
        <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Wind & Waves</h4>
        <div className="relative rounded-lg overflow-hidden" style={{ height: '400px' }}>
          {mapsLoading.wind && (
            <div className="absolute inset-0 bg-gray-100 dark:bg-gray-700 flex items-center justify-center z-10">
              <div className="text-center">
                <RefreshCw className="w-8 h-8 animate-spin mx-auto text-orange-500 mb-2" />
                <p className="text-sm text-gray-600 dark:text-gray-400">Loading wind map...</p>
              </div>
            </div>
          )}
          <iframe
            src="https://embed.windy.com/embed2.html?lat=29.678&lon=-85.3674&detailLat=29.678&detailLon=-85.3674&width=650&height=400&zoom=11&level=surface&overlay=wind&product=ecmwf&menu=&message=&marker=true&calendar=now&pressure=&type=map&location=coordinates&detail=&metricWind=mph&metricTemp=%C2%B0F&radarRange=-1"
            frameBorder="0"
            style={{ width: '100%', height: '100%' }}
            title="Windy Wind Map"
            sandbox="allow-scripts allow-same-origin"
            loading="lazy"
            onLoad={() => setMapsLoading(prev => ({ ...prev, wind: false }))}
          ></iframe>
        </div>
      </div>
      
      {/* Radar Map */}
      <div className="mb-4">
        <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Radar</h4>
        <div className="relative rounded-lg overflow-hidden" style={{ height: '400px' }}>
          {mapsLoading.radar && (
            <div className="absolute inset-0 bg-gray-100 dark:bg-gray-700 flex items-center justify-center z-10">
              <div className="text-center">
                <RefreshCw className="w-8 h-8 animate-spin mx-auto text-orange-500 mb-2" />
                <p className="text-sm text-gray-600 dark:text-gray-400">Loading radar map...</p>
              </div>
            </div>
          )}
          <iframe
            src="https://embed.windy.com/embed2.html?lat=29.678&lon=-85.3674&detailLat=29.678&detailLon=-85.3674&width=650&height=400&zoom=9&level=surface&overlay=radar&product=radar&menu=&message=&marker=true&calendar=now&pressure=&type=map&location=coordinates&detail=&metricWind=mph&metricTemp=%C2%B0F&radarRange=-1"
            frameBorder="0"
            style={{ width: '100%', height: '100%' }}
            title="Windy Radar Map"
            sandbox="allow-scripts allow-same-origin"
            loading="lazy"
            onLoad={() => setMapsLoading(prev => ({ ...prev, radar: false }))}
          ></iframe>
        </div>
      </div>
      
      <a 
        href="https://www.windy.com/?29.671,-85.355,11" 
        target="_blank" 
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 text-sm text-blue-600 dark:text-blue-400 hover:underline"
      >
        Open full Windy.com 
        <ChevronRight className="w-4 h-4" />
      </a>
    </div>
  );
};

WeatherMaps.propTypes = {};

export default memo(WeatherMaps);